import { Component } from 'react';
import getUserData from './getUserData';

export default class IpData extends Component {
	async componentDidMount() {
		await getUserData();
	}
	render() {
		return null;
	}
}
